import React, { useState } from "react";
import { Button } from "../../../design/button";
import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogTitle,
} from "../../../design/dialog";
import { PlusIcon } from "@heroicons/react/16/solid";
import { Input } from "../../../design/input";
import {
  Field,
  Fieldset,
  FieldGroup,
  Label,
  ErrorMessage,
} from "../../../design/fieldset";
import { useMatter } from "../../../contexts/MatterContext";
import { Textarea } from "../../../design/textarea";
import { Matter } from "../../../models/Matter";
import SelectMatterType from "../../../components/SelectMatterType";
import SelectClient from "../../../components/SelectClient";
import { User } from "../../../models/User";

interface Props {
  children?: React.ReactNode;
  onMatterCreated?: (matterId: string) => void;
}

interface Errors {
  identifier?: string;
  summary?: string;
  client?: string;
}

const CreateMatterButton: React.FC<Props> = ({ children, onMatterCreated }) => {
  const { createMatter } = useMatter();
  const [isOpen, setIsOpen] = useState(false);

  const [errors, setErrors] = useState<Errors>({});
  const [isSaving, setIsSaving] = useState(false);
  const [identifier, setIdentifier] = useState<string>("");
  const [summary, setMatterSummary] = useState<string>("");
  const [matterType, setMatterType] = useState<
    Matter["matterType"] | undefined
  >(undefined);
  const [client, setClient] = useState<User["_id"] | undefined>(undefined);

  const validateForm = () => {
    const newErrors: { [key: string]: string } = {};
    if (!identifier.trim()) {
      newErrors.text = "A text is required.";
    }
    if (!summary.trim()) {
      newErrors.summary = "A matter summary is required.";
    }
    if (!client) {
      newErrors.client = "A client is required.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    console.log("handleSubmit called");
    console.log("matterType:", matterType);
    console.log("client:", client);
    console.log("identifier:", identifier);
    console.log("summary:", summary);
    if (!validateForm()) {
      return;
    }
    setIsSaving(true);
    try {
      // const matterId = await createMatter({
      //   identifier,
      //   summary,
      //   matterType: matterType!,
      //   client: client!,
      // });
      if (onMatterCreated) {
        // onMatterCreated(matterId);
      }
      clearForm();
    } catch (error) {
      console.error("Error creating location:", error);
    } finally {
      setIsSaving(false);
    }
  };

  const clearForm = () => {
    setIsOpen(false);
    setIdentifier("");
    setMatterSummary("");
    setMatterType("general");
    setErrors({});
  };

  return (
    <>
      <Button type="button" onClick={() => setIsOpen(true)}>
        {children ?? (
          <div className="flex items-center gap-2">
            <PlusIcon className="w-4 h-4" />
            <span className="hidden sm:block">Create Matter</span>
          </div>
        )}
      </Button>
      <Dialog open={isOpen} onClose={setIsOpen}>
        <DialogTitle>Create Matter</DialogTitle>
        <DialogBody>
          <Fieldset>
            <FieldGroup>
              <Field>
                <Label htmlFor="identifier">Identifier</Label>
                <Input
                  id="identifier"
                  type="text"
                  placeholder="Enter matter identifier"
                  value={identifier}
                  onChange={(e) => setIdentifier(e.target.value)}
                />
                {errors.identifier && (
                  <ErrorMessage>{errors.identifier}</ErrorMessage>
                )}
              </Field>
              <Field>
                <Label htmlFor="summary">Matter Summary</Label>
                <Textarea
                  id="summary"
                  placeholder="Enter matter summary"
                  value={summary}
                  onChange={(e) => setMatterSummary(e.target.value)}
                />
                {errors.summary && (
                  <ErrorMessage>{errors.summary}</ErrorMessage>
                )}
              </Field>
              <Field>
                {/* <Label htmlFor="matterType">Matter Type</Label>
                <SelectMatterType
                  value={matterType}
                  onChange={(type) => setMatterType(type)}
                /> */}
              </Field>
              <Field>
                <Label htmlFor="client">Client</Label>
                <SelectClient
                  value={client}
                  onChange={(client) => setClient(client)}
                />
              </Field>
            </FieldGroup>
          </Fieldset>
        </DialogBody>
        <DialogActions>
          <Button plain onClick={clearForm}>
            Cancel
          </Button>
          <Button disabled={isSaving} onClick={handleSubmit}>
            {isSaving ? "Saving..." : "Save"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CreateMatterButton;
